export class BaoHeader extends window.BAO.HideableStickyHeader {
  static get requiredAttributes () {
    return super.requiredAttributes.concat(['data-solid'])
  }

  static get styles () {
    return `
      :host {
        background-color: rgba(51, 51, 51, 0.01);
        backdrop-filter: blur(5px);
        color: var(--Color_White-soft);

        transition: background-color 0.3s ease, backdrop-filter 0.3s ease, color 0.3s ease;
      }

      :host([data-solid="true"]) {
        background-color: #fff;
        backdrop-filter: none;
        color: var(--Color_Dark);
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    this.setHeaderHeight()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'resize', this.onResize.bind(this))
  }

  onResize () {
    this.setHeaderHeight()
  }

  setHeaderHeight () {
    const styles = this.getBoundingClientRect()

    document.documentElement.style.setProperty(
      '--Header_Height',
      `${styles.height}px`,
    )
  }

  get solid () {
    return this.dataset.solid === 'true'
  }

  set solid (val) {
    this.dataset.solid = val.toString()
  }
}

if (!customElements.get('bao-header')) {
  customElements.define('bao-header', BaoHeader)
}
